import script from "./ChangeHours.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeHours.vue?vue&type=script&setup=true&lang=js"

import "./ChangeHours.vue?vue&type=style&index=0&id=2549461f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2549461f"]])

export default __exports__